import React from 'react';
import ProductDetail from '../components/product/ProductDetail';

const ProductDetailPage = () => {
  return <ProductDetail />;
};

export default ProductDetailPage;
